module.exports = __webpack_public_path__ + "static/media/nyquiz.63a924e5.svg";